import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import EditOrder from './Pages/EditOrder/EditOrder'
import PBFBaseLayout from './layouts/PBFLayout'
import PBFLandingPage from './Pages/Landing/PBFLandingPage'
import ErrorBoundaryComponent from '@/components/ErrorBoundaryComponent/ErrorBoundaryComponent'
import OrderOverview from './Pages/OrderOverview/OrderOverview'
import { getCompanySettingRef } from '../SystemConfigure/UserManagment/UserManagment.service'
import { useQuery } from 'react-query'
import {
  COMPANY_SETTING_NAME_HIDE_ORDER_PROPERTIES,
  COMPANY_SETTING_NAME_HIDE_ORDER_ACTIONS,
} from '@/constant/user'
import { PBF_QUERY_KEY } from '@/constant/pbf'
import { includes } from 'lodash'

const { COMPANY_SETTING_HIDE_ORDER_PROP } = PBF_QUERY_KEY

export default function PBFRoute() {
  const route = useLocation()
  const isMatchEditOrder = includes(route.pathname, '/pbf/orders/edit-order')
  const isMatchViewOrder = includes(route.pathname, '/pbf/orders')
  const isMatchOrderList = includes(route.pathname, '/pbf')

  const { data: dataOrderHideProps } = useQuery(
    [COMPANY_SETTING_HIDE_ORDER_PROP],
    async () => {
      return await getCompanySettingRef(
        '',
        COMPANY_SETTING_NAME_HIDE_ORDER_PROPERTIES
      )
    },
    { enabled: isMatchEditOrder || isMatchViewOrder }
  )

  const { data: dataOrderHideActions } = useQuery(
    [COMPANY_SETTING_NAME_HIDE_ORDER_ACTIONS],
    async () => {
      return await getCompanySettingRef(
        '',
        COMPANY_SETTING_NAME_HIDE_ORDER_ACTIONS
      )
    },
    { enabled: isMatchOrderList }
  )

  return (
    <ErrorBoundaryComponent>
      <Routes>
        <Route path="" element={<PBFBaseLayout />}>
          <Route
            path=""
            element={<PBFLandingPage hideActions={dataOrderHideActions} />}
          />
          <Route path="orders">
            {/* Create New Order */}
            <Route
              path="edit-order"
              element={<EditOrder hideProperties={dataOrderHideProps} />}
            />
            <Route
              path="edit-order/:id"
              element={<EditOrder hideProperties={dataOrderHideProps} />}
            />
            <Route
              path=":id"
              element={
                <OrderOverview
                  hideActions={dataOrderHideActions}
                  hideProperties={dataOrderHideProps}
                />
              }
            />
            <Route path="" element={<Navigate to="/pbf" replace={true} />} />
          </Route>
        </Route>
      </Routes>
    </ErrorBoundaryComponent>
  )
}
